<span>
  <ng-container i18n>Liczba dostępnych rekordów</ng-container>:
  <strong>{{ numberOfRecords }}</strong>
</span>
